import { render, staticRenderFns } from "./Authority.vue?vue&type=template&id=4a0d1e79&"
import script from "./Authority.vue?vue&type=script&lang=ts&"
export * from "./Authority.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports